import { toWSDateString } from "@wingspanhq/fe-component-library";
import { US_STATES_OPTIONS } from "../../constants/user";
import { FILING_STATUS_OPTIONS } from "./constants";

export function formatFilingStatus(filingStatus?: string) {
  return FILING_STATUS_OPTIONS.find(option => option.value === filingStatus)
    ?.label;
}

export function formatStateOfResidence(stateOfResidence?: string) {
  return US_STATES_OPTIONS.find(option => option.value === stateOfResidence)
    ?.label;
}
/**
 * Formats an internal deadline Date as "Mon DD, YYYY at 9:00 AM EST".
 * The time is hardcoded because the upstream `getTaxPaymentInternalDeadline`
 * always sets the deadline to 9:00 AM ET, but `toWSDateString` would render
 * the hour in the user's local timezone — causing the displayed time to be
 * wrong for anyone outside Eastern Time.
 */
export const formatInternalDeadline = (deadline: Date): string =>
  `${toWSDateString(deadline, "monthDayYear")} at 9:00 AM EST`;
